module.exports = __webpack_public_path__ + "fonts/Roboto-Medium.3b852b6.otf";